<template>
  <div class="container-fluid">

    <div class="row py-3">
      <div class="col-md-12">
        <h1 class="text-center">Create client</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-10 col-lg-8 col-xl-6 mx-auto pt-3">
        <div v-if="createMode">
          <create-client-form @createSuccess="toggleMode" :groups="groups"></create-client-form>
        </div>

        <div v-else class="text-center">
          <h2>The client was created successfully</h2>
          <button @click="toggleMode" class="btn btn-lg btn-success" type="button">Create new client</button>
        </div>

        <loading :loading="loading"></loading>

      </div>
    </div>

  </div>
</template>


<script>
import CreateClientForm from '../components/forms/CreateClientForm'

export default {
  components: {
    CreateClientForm,
  },
  created() {
    this.loading = true
    this.$store.dispatch('loadGroups')
      .finally(() => {
        this.loading = false
      })
  },
  data() {
    return {
      createMode: true,
      loading: false,
    }
  },
  computed: {
    groups() {
      return this.$store.getters.getGroups
    },
  },
  methods: {
    toggleMode() {
      this.createMode = !this.createMode
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/CreateClientPage.vue